import { useMutation } from '@tanstack/react-query';

import { queryClient } from '../../App';
import { axiosInstance } from '../../axios/axiosInstance';
import { key as InboxKey } from './useGetInbox';
import { key as LatestKey } from './useGetLatestMessages';

const url = 'api/member/inbox/conversations/';
export const useReadMessage = () =>
  useMutation(
    [],
    async ({ userId, id }: { userId: number; id: unknown }): Promise<void> => {
      id && (await axiosInstance.get(`${url}${userId}/${id as string}/read`));
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([...InboxKey]);
        queryClient.invalidateQueries([...LatestKey]);
      }
    }
  );
